import api from "../api";
import apiNoAuth from "../apiNoAuth";
export class AuthorizationService {

    static async login(data){
        try{
            return await api.post(`auth/login`,data)
        }catch (error){
            console.log('Login request failed:', error?.response?.data || error)
            throw error
        }
    }

    static createStakeholderUser(data){
        return apiNoAuth.post(`auth/user/create`,data).catch(e=>{
            console.log(e);
        })
    }
    static listRoles(){
        return api.get(`auth/groups`).catch(e=>{ console.log(e);})
    }

    static changePassword(data) {
        return api.post(`auth/change-password`, {
            old_password: data.current_password,
            new_password: data.new_password
        }).then(response => {
            if (response.data && response.data.detail) {
                throw new Error(response.data.detail);
            }
            return response;
        }).catch(e => {
            console.log('Password change error:', e.response?.data || e);
            throw e;
        });
    }
}